import { connect } from 'react-redux'
import { RootState } from 'typesafe-actions';
import { ThunkDispatch } from 'redux-thunk';
import * as act from '../../Quote/actions/OrderActions';
import { RouteComponentProps } from 'react-router';
import HistoricalOrders from '../components/Restaurant/HistoricalOrders';


const mapStateToProps = (state: RootState) => ({
    isBusy: state.orderRdc.getHistoricalOrdersBusy,
    historicalOrders: state.orderRdc.historicalOrders,
})

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {
    return ({
        getHistoricalOrders: async () => {
            await dispatch(act.getHistoricalOrdersAsyncThunk())
        }
    })
}

export type HistoricalOrdersProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & RouteComponentProps & {mode: "widget" | "browser" }

const HistoricalOrdersCnn = connect(
    mapStateToProps,
    mapDispatchToProps
)(HistoricalOrders);

export default HistoricalOrdersCnn